<!-- search section -->
<section class="banner">
  <div #air id="air" class="air"></div>
  <!-- kenburns-top -->
  <app-nav class="w-100"></app-nav>
  <!-- Search Section -->
  <div class="head-component-ui">
    <div class="searchbar" data-aos="fade-down">
      <div class="hometitle mob-view">
        <span class="sstarabicbold text-mobile-size search-txt">
          {{ "Knowledge portal" | translator }}
        </span>
        <span class="sstarabicbold">
          <div class="pi pi-times-circle" routerLink="/home" style="cursor: pointer"></div>

          <i class="pi pi-file-edit me-2 p-1" style="font-size: 2rem" aria-hidden="true"></i>
          {{ "Content update logs" | translator }}
        </span>
      </div>

      <div class="">
        <div class="" style="position: relative">
          <!-- form data => (ngSubmit)="handleSubmit($event)" -->
          <span class="p-input-icon-right w-100">
            <i class="pi pi-search" style="margin-right: 10px; width: 30px"></i>
            <!-- input data => [(ngModel)]="searchFilterValue" (ngModelChange)="handleFilter('SEARCH',searchFilterValue)" -->
            <input filterButton pInputText name="search" [(ngModel)]="searchText"
              class="form-control header-input-ui form-control-lg px-5 shadow-sm sstarabicbold"
              (keydown.enter)="getContentUpdates()" type="text" dir="rtl" placeholder="{{ 'Discus' | translator }}" />
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- skelition   -->
  <app-skelitions [hidden]="!skelition" [value]="8" class="mb-2"></app-skelitions>
  <!-- skelition  END -->

  <div [hidden]="skelition" class="container-fluid">
    <!-- style="background:#F3F3F3;" -->
    <!-- <div class="container max-width-1200px"> -->

    <div class="container">
      <label class="filter-ui my-3">
        <h3 class="d-flex" (click)="showFilters = true">
          <b class="d-flex align-items-end"><i class="pi pi-filter filter-icon-size"></i><span class="mx-2">{{ "filter"
              | translator }}</span>
            <i class="pi pi-angle-down" [ngClass]="
                showFilters
                  ? 'pi pi-angle-left filter-icon-size'
                  : 'pi pi-angle-down filter-icon-size'
              "></i>
          </b>
        </h3>
        <span *ngIf="data?.length > 0" class="d-flex align-items-center mt-3">
          <h6 [hidden]="!logStatus || !logStatusFilterLabel" class="color-white mx-2">
            {{ logStatusFilterLabel }}<i class="pi pi-angle-left"></i>
          </h6>
          <h6 [hidden]="!logType || !logTypeFilterLabel" class="color-white mx-2">
            {{ logTypeFilterLabel }}<i class="pi pi-angle-left"></i>
          </h6>
          <h6 [hidden]="!typeFilter || !typeFilterLabel" class="color-white mx-2">
            {{ typeFilterLabel }}<i class="pi pi-angle-left"></i>
          </h6>
          <h6 *ngIf="oufilter && oufilter?.data" class="heading mx-2">
            <img *ngIf="checkisImg(oufilter?.data); else elseBlock" src="{{ staticURL }}{{ oufilter?.data }}"
              class="img-fluid p-1 tree-img-bg" style="max-height: 30px; max-width: 30px" />
            <ng-template #elseBlock>
              <i class="{{ oufilter.data }} p-2" style="font-size: 1rem"></i>
            </ng-template>
            {{ oufilter?.label }}
          </h6>
          <h6 [hidden]="!searchText" class="heading mx-2">{{ searchText }}</h6>
        </span>
        <!-- <p >{{typeOptions?.arabic}}</p> -->
      </label>
    </div>

    <div [hidden]="!showFilters" class="container bg-rgb mb-3">
      <div class="flex-wrap my-2 px-3">
        <div class="d-flex justify-content-between col-bg mob-column">
          <div class="d-flex flex-wrap">
            <div>
              <h4 class="mb-0 px-2 mt-10">
                <b class="border-botom"><i class="pi pi-check-square mx-2"></i>{{ "the condition" | translator }}</b>
              </h4>
            </div>
            <div class="mob-my-2 v4-active">
              <p-selectButton class="v4-active" [options]="statusOptions" [(ngModel)]="logStatus" optionLabel="arabic"
                optionValue="name"></p-selectButton>
            </div>
          </div>
          <div class="mob-my-2">
            <button pButton pRipple label="{{ 'Discuss' | translator }}" (click)="getContentUpdates()"
              icon="pi pi-search" class="mx-2 color-purple"></button>
            <button pButton pRipple label="{{ 'Reset' | translator }}" (click)="refresh()" icon="pi pi-refresh"
              class="mx-2 color-purple"></button>
          </div>
        </div>
        <label class="border-botom">
          <h4>
            <b><i class="pi pi-filter mx-2"></i>{{ "Services filter" | translator }}</b>
          </h4>
        </label>
        <!-- Service Filter -->
        <div class="row d-flex my-2">
          <div class="col-md-4 col-12 my-1">

            <p-dropdown filterButton [options]="ouTypes" [(ngModel)]="typeFilter" placeholder="{{ 'Choose Type' | translator }}"
            (onChange)="typeFilter = $event.value"
              [filter]="true" styleClass="md:mb-0 sstarabic w-100" class="ppp-dropdown">
              <ng-template let-item pTemplate="item">
                <i [ngClass]="item.icon"></i>
                {{ item.label }}
              </ng-template>
            </p-dropdown>
          </div>

          <div class="col-md-8 col-12 my-1">
            <p-treeSelect filterButton class="v4-tree w-md-20rem w-100 ppp-tree-select" containerStyleClass="w-100"
              [(ngModel)]="oufilter" [options]="selectedTreeData" appendTo="body"
              (onNodeSelect)="filterFunctionByPostOuFilter($event)"
              placeholder="{{ 'Choose the organizational unit' | translator }}" [filter]="true"
              [filterInputAutoFocus]="true">
              <ng-template let-node pTemplate="default">
                <div class="d-flex">
                  <img *ngIf="checkisImg(node.data); else elseBlock" src="{{ staticURL }}{{ node.data }}"
                    class="img-fluid p-1 tree-img-bg" style="max-height: 30px; max-width: 30px" />
                  <ng-template #elseBlock>
                    <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
                  </ng-template>
                  <b class="text-nowrap">{{ node.label }}</b>
                </div>
              </ng-template>
            </p-treeSelect>
          </div>
          <div class="col-md-4 col-12 my-1"></div>
        </div>
        <!-- End Service Filter -->
        <!-- Log Filter -->
        <div class="d-flex flex-wrap">
          <div class="column mob-web-mx margin-mob mob-width">
            <div>
              <p class="mt-3">
                <b class="border-botom"><i class="pi pi-calendar-plus mx-2"></i>{{ "starting date" | translator }}</b>
              </p>
            </div>
            <div class="v4-calander">
              <p-calendar filterButton class="v4-calander" [(ngModel)]="start_date" (onSelect)="start_date = $event"  dir="ltr" [showIcon]="true"></p-calendar>
            </div>
          </div>
          <div class="column mob-web-mx margin-mob mob-width">
            <div>
              <p class="mt-3">
                <b class="border-botom"><i class="pi pi-calendar-minus mx-2"></i>{{ "Expiry date" | translator }}</b>
              </p>
            </div>
            <div class="v4-calander">
              <p-calendar filterButton class="v4-calander" [(ngModel)]="end_date" (onSelect)="end_date = $event" dir="ltr" [showIcon]="true"></p-calendar>
            </div>
          </div>

          <div class="column mob-web-mx margin-mob mob-width">
            <div>
              <p class="mt-3 px-2">
                <b class="border-botom"><i class="fa-solid fa-user-pen v4-ml-2"></i>{{ "Request before" | translator
                  }}</b>
              </p>
            </div>
            <div class="v4-active">
              <p-dropdown filterButton class="v4-dropp" [options]="contentUpdateUsers?.updated_by" [(ngModel)]="updatedBy"
              (onChange)="updatedBy = $event.value"
                [filter]="true" filterBy="name" [editable]="true" optionLabel="name"></p-dropdown>
            </div>
          </div>

          <div class="column mob-web-mx margin-mob mob-width">
            <div>
              <p class="mt-3 px-2">
                <b class="border-botom"><i class="fa-solid fa-user-check v4-ml-2"></i>{{ "Approved by" | translator
                  }}</b>
              </p>
            </div>
            <div class="v4-active">
              <p-dropdown filterButton (ngModelChange)="print({approvedBy, $event})" class="v4-dropp" [options]="contentUpdateUsers?.approved_by" [(ngModel)]="approvedBy"
              (onChange)="approvedBy = $event.value"
                [filter]="true" filterBy="name" [editable]="true" optionLabel="name"></p-dropdown>
            </div>
          </div>

          <div class="column margin-mob mob-width">
            <div>
              <p class="mt-3 px-2">
                <b class="border-botom"><i class="pi pi-sitemap mx-2"></i>{{ "Type" | translator }}</b>
              </p>
            </div>
            <div class="v4-active">
              <p-selectButton class="v4-active" [options]="typeOptions" [(ngModel)]="logType" optionLabel="arabic"
                optionValue="name"></p-selectButton>
            </div>
          </div>

          <div class="column mob-web-mx margin-mob mob-width">
            <div>
              <p class="mt-3">
                <b class="border-botom"><i class="fa-solid fa-download mx-2"></i>{{ "Download" | translator }}</b>
              </p>
            </div>
            <div class="v4-calander">
              <button class="excel-button v4-py" (click)="exportExcel()">
                <!--  -->
                <i class="fa-regular fa-file-excel mx-2"></i>
                <p-progressSpinner class="v4-spin" *ngIf="downloadExcel" ariaLabel="loading"></p-progressSpinner>
              </button>
            </div>
          </div>
        </div>
        <!-- End Log Filter -->
      </div>
    </div>

    <!-- stats container -->
    <div class="container">
      <div *ngIf="totalRecords" class="row">
        <div class="col-md-2 col-12 flex-row">
          <h5 class="text-light">{{ "Total Records" | translator }}</h5>
          <div class="row">
            <div class="col v4-bg rounded p-3 m-2 text-center align-items-center" style="height: 120px">
              <!-- p>{{logStatus_set | translator}}</p -->
              <h1>{{ totalRecords }}</h1>
            </div>
          </div>
        </div>

        <div *ngIf="contentstats_data_types?.length > 0" class="col-md-4 col-12 flex-row">
          <h5 class="text-light">{{ "data types" | translator }}</h5>
          <div class="row">
            <div *ngFor="let type of contentstats_data_types" style="height: 120px"
              class="col v4-bg rounded p-3 m-2 text-center align-items-center">
              <p>
                {{ type._id ? type._id : ("Deleted data type" | translator) }}
              </p>
              <h5>{{ type.count }}</h5>
            </div>
          </div>
        </div>

        <div *ngIf="contentstats_types?.length > 0" class="col-md-6 col-12 flex-row">
          <h5 class="text-light">{{ "Content Update Type" | translator }}</h5>

          <div class="row">
            <div *ngFor="let type of contentstats_types" style="height: 120px"
              class="col v4-bg rounded p-3 m-2 text-center align-items-center">
              <p>{{ type._id | translator }}</p>
              <h5>{{ type.count }}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid mob-bottom-p" style="transform: scale(0.95, 0.95)">
      <div [hidden]="skelition" class="row p-bottom">
        <span [hidden]="data?.length > 0">
          <!-- <app-no-data [hidden]="data?.length > 0"></app-no-data> -->
          <div [hidden]="data?.length > 0" class="container-fluid">
            <div class="container d-flex justify-content-center">
              <h5 class="la-tujad">
                {{ "There is no data" | translator
                }}<i class="pi pi-fw pi-exclamation-triangle font-2rem mx-2"></i>
              </h5>
            </div>
          </div>
        </span>
        <!-- scroll view -->
        <div [ngClass]="{
            'col-lg-6 col-md-6 col-12 fixed-column slide-right': side_view,
            'col-lg-12 col-md-12 col-12': !side_view
          }">
          <span *ngIf="data?.length > 0" class="d-flex align-items-center white-head-box">
            <img class="svg-icon-heading" src="../../../../../assets/v-4-icone/Layer-2.svg" alt="loading" />

            <h5 class="heading mx-2">
              {{ logStatus_set | translator }}
              <!-- {{ "update requests" | translator }} -->
            </h5>
          </span>
          <div   class="{{ side_view ? 'v4-height' : '' }}" >
            <div class="{{ side_view ? 'v4-scroll' : '' }}"   >
              <div *ngFor="let log of data" (click)="openLog(log)" class="{{
                  (log.status == 'PENDING' || log.status == 'APPROVED') &&
                  log._id == selectedViewId
                    ? 'logs-box'
                    : 'log-default'
                }}" id="{{log._id}}" >

                
              <!-- Edit Log -->
                <span *ngIf="log.type == 'EDIT'">
                  <span class="flex-align-flex mt-2">
                    <img class="svg-icon" src="../../../../../assets/v-4-icone/Layer1.svg" alt="loading" />
                    <span class="color-bold mx-2">{{
                      "Release" | translator
                      }}</span>
                  </span>
                  <span *ngIf="log.status == 'PENDING'">
                    <p-accordion class="v4-accordian" (onOpen)="openLog(log)" (onClose)="openLog(log)" class="w-full"
                      [multiple]="true">
                      <p-accordionTab class="my-3 v4-accordian">
                        <ng-template pTemplate="header" class="v4-accordian">
                          <div class="container-fluid flex-mob-web">
                            <div class="d-flex">
                              <i [ngClass]="
                                  log?.before?.dataview.type?.icon +
                                  ' font-1_2rem'
                                " class="m-2"></i>
                              <span class="vertical-align-middle font-1_1rem d-flex">{{ log?.before?.name }} ({{
                                log?.before?.dataview.type?.arabic
                                }})</span>
                            </div>
                            <div class="mob-mr">
                              <span>({{ log.createdAt | date }})</span>
                            </div>
                          </div>
                        </ng-template>
                        <!-- Name Is Edited -->
                        <ng-template pTemplate="content">
                          <div [hidden]="log?.after.name == log?.before?.name">
                            <span class="color-bold"><i class="pi pi-pencil mx-2"></i>{{ "Update address" | translator
                              }}:</span>
                            {{ log?.after?.name }}
                          </div>
                          <!-- End Name Is Edited -->
                          <p-accordion class="w-full" [multiple]="true">
                            <span *ngFor="
                                let field of log?.after?.fields;
                                let i = index
                              ">
                              <p-accordionTab class="my-3" *ngIf="field?.wasEdited" iconPos="end">
                                <ng-template pTemplate="header">
                                  <div class="d-flex align-items-center">
                                    <p-checkbox (click)="$event.stopPropagation()" [(ngModel)]="field.isChecked"
                                      class="shadow" [binary]="true" inputId="binary"></p-checkbox>

                                    <i [ngClass]="
                                        field?.label?.icon + ' font-1_2rem'
                                      " class="m-2"></i>
                                    <span class="vertical-align-middle font-1_1rem">{{ field?.label?.name }}</span>
                                  </div>
                                </ng-template>
                                <ng-template pTemplate="content">
                                  <div class="d-flex justify-content-between">
                                    <div class="w-100" [ngSwitch]="
                                        getFieldType(field?.label?.type)
                                      ">
                                      <!-- For text -->
                                      <div *ngSwitchCase="'text'">
                                        <i class="pi pi-clone"></i>
                                        <input pInputText [(ngModel)]="field.data" class="w-100" [id]="field?.label"
                                          type="text" />
                                      </div>
                                      <!-- Rich text -->
                                      <div *ngSwitchCase="'Rich text'">
                                        <p-editor [(ngModel)]="field.data" [style]="{ height: '320px' }"></p-editor>
                                      </div>
                                      <div *ngSwitchCase="'Upload Image'">
                                        <img [hidden]="field.data == ''" class="img-fluid upload-img-dActive" [src]="
                                            GlobalConstants.staticFilesURL +
                                            field.data
                                          " />
                                        <p-fileUpload mode="basic" chooseLabel="Choose" name="file"
                                          [url]="apilink + 'file/data'" [auto]="true" chooseLabel="Browse"
                                          accept="image/*" [maxFileSize]="1000000" (onUpload)="
                                            field.data =
                                              $event.originalEvent.body.data
                                          "></p-fileUpload>
                                      </div>
                                      <div *ngSwitchCase="'Upload Document'">
                                        <a class="doc-view-dActive" [hidden]="field.data == ''" target="_blank" [href]="
                                            GlobalConstants.staticFilesURL +
                                            field.data
                                          ">
                                          <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{ "Add file" |
                                          translator }}
                                        </a>
                                        <p-fileUpload mode="basic" chooseLabel="Choose" name="file"
                                          [url]="apilink + 'file/data'" [auto]="true" chooseLabel="Add File"
                                          [maxFileSize]="100000000" (onUpload)="
                                            field.data =
                                              $event.originalEvent.body.data
                                          "></p-fileUpload>
                                      </div>
                                      <div *ngSwitchCase="'Data Item'">
                                        <button type="submit" (click)="toggleModal(i)" pButton pRipple
                                          label="{{ 'to update' | translator }}" icon="pi pi-fw pi-plus-circle"
                                          class="w-full my-3"></button>
                                        <p-dialog [blockScroll]="true" [draggable]="false"
                                          header="{{ 'Select' | translator }}" [(visible)]="modalVisibilities[i]"
                                          [style]="{
                                            width: '95vw',
                                            maxWidth: '1000px'
                                          }">
                                          <app-select-service (currentDataItem)="
                                              changeCurrentDataItem(
                                                $event,
                                                field,
                                                i
                                              )
                                            "></app-select-service>
                                        </p-dialog>
                                        <p class="font-bold" *ngIf="field.data">
                                          {{ field.data.name }}
                                        </p>
                                      </div>
                                      <div *ngSwitchDefault></div>
                                    </div>
                                  </div>
                                </ng-template>
                              </p-accordionTab>
                            </span>
                          </p-accordion>
                        </ng-template>
                      </p-accordionTab>
                    </p-accordion>
                  </span>
                  <span *ngIf="log.status == 'APPROVED' || log.status == 'REJECTED'">
                    <p-accordion (onOpen)="openLog(log)" (onClose)="openLog(log)" class="w-full" [multiple]="true">
                      <p-accordionTab class="my-3">
                        <ng-template pTemplate="header">
                          <div class="container-fluid flex-mob-web">
                            <div>
                              <i [ngClass]="
                                  log?.before?.dataview?.type?.icon +
                                  ' font-1_2rem'
                                " class="m-2"></i>
                              <span class="vertical-align-middle font-1_1rem">{{ log?.before?.name }} ({{
                                log?.before?.dataview?.type?.arabic
                                }})</span>
                            </div>
                            <div class="mob-mr">
                              <span>({{ log.createdAt | date }})</span>
                            </div>
                          </div>
                        </ng-template>
                        <!-- Name Is Edited -->
                        <ng-template pTemplate="content">
                          <p class="color-bold mx-2">
                            {{ "User updates" | translator }}
                          </p>
                          <div [hidden]="log?.after?.name == log?.before?.name">
                            <span class="color-bold"><i class="pi pi-pencil mx-2"></i>{{ "Address update" | translator
                              }}:&nbsp;</span>
                            &nbsp;{{ log?.after?.name }}
                          </div>
                          <!-- End Name Is Edited -->

                          <p-accordion class="w-full" [multiple]="true">
                            <span *ngFor="
                                let field of log.after?.fields;
                                let i = index
                              ">
                              <p-accordionTab class="my-3" *ngIf="field.wasEdited" iconPos="end">
                                <ng-template pTemplate="header">
                                  <div class="d-flex align-items-center justify-content-between w-100">
                                    <span>
                                      <i [ngClass]="
                                          field.label?.icon + ' font-1_2rem'
                                        " class="m-2"></i>
                                      <span class="vertical-align-middle font-1_1rem">{{ field.label?.name }}</span>
                                    </span>
                                    <span *ngIf="!field.isChecked" class="d-flex">
                                      <i class="times-cross pi pi-times"></i>
                                    </span>
                                  </div>
                                </ng-template>
                                <ng-template pTemplate="content">
                                  <div class="">
                                    <div [ngSwitch]="
                                        getFieldType(field.label?.type)
                                      ">
                                      <!-- For text -->
                                      <div *ngSwitchCase="'text'">
                                        <div class="d-flex flex-column mb-0 datacontent" *ngIf="field.data"
                                          [innerHTML]="field.data | safeHTML"></div>
                                      </div>
                                      <!-- Rich text -->
                                      <div *ngSwitchCase="'Rich text'">
                                        <div class="d-flex flex-column mb-0 datacontent" *ngIf="field.data"
                                          [innerHTML]="field.data | safeHTML"></div>
                                      </div>
                                      <div *ngSwitchCase="'Upload Image'">
                                        <img [hidden]="field.data == ''" class="img-fluid upload-img" [src]="
                                            GlobalConstants.staticFilesURL +
                                            field.data
                                          " />
                                      </div>
                                      <div *ngSwitchCase="'Upload Document'">
                                        <a class="doc-view" [hidden]="field.data == ''" target="_blank" [href]="
                                            GlobalConstants.staticFilesURL +
                                            field.data
                                          ">
                                          <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{ "Add file" |
                                          translator }}
                                        </a>
                                      </div>
                                      <div *ngSwitchCase="'Data Item'">
                                        <p class="color-bold mx-2">
                                          {{ field?.data?.name }}
                                        </p>
                                        <p-accordion class="w-100" [multiple]="true">
                                          <p-accordionTab class="my-3" *ngFor="
                                              let field of field.data.fields;
                                              let i = index
                                            " iconPos="end">
                                            <ng-template pTemplate="header">
                                              <div class="d-flex align-items-center">
                                                <i [ngClass]="
                                                    field.label?.icon +
                                                    ' font-1_2rem'
                                                  " class="m-2"></i>
                                                <span class="vertical-align-middle font-1_1rem">{{ field.label?.name
                                                  }}</span>
                                              </div>
                                            </ng-template>
                                            <ng-template pTemplate="content">
                                              <div class="row">
                                                <div class="col-10">
                                                  <div [ngSwitch]="
                                                      getFieldType(
                                                        field.label?.type
                                                      )
                                                    ">
                                                    <!-- For text -->
                                                    <div *ngSwitchCase="'text'">
                                                      <div class="d-flex flex-column mb-0 datacontent"
                                                        *ngIf="field.data" [innerHTML]="
                                                          field.data | safeHTML
                                                        "></div>
                                                    </div>
                                                    <!-- Rich text -->
                                                    <div *ngSwitchCase="
                                                        'Rich text'
                                                      ">
                                                      <div class="d-flex flex-column mb-0 datacontent"
                                                        *ngIf="field.data" [innerHTML]="
                                                          field.data | safeHTML
                                                        "></div>
                                                    </div>
                                                    <div *ngSwitchCase="
                                                        'Upload Image'
                                                      ">
                                                      <img [hidden]="
                                                          field.data == ''
                                                        " class="img-fluid upload-img" [src]="
                                                          GlobalConstants.staticFilesURL +
                                                          field.data
                                                        " />
                                                    </div>
                                                    <div *ngSwitchCase="
                                                        'Upload Document'
                                                      ">
                                                      <a class="doc-view" [hidden]="
                                                          field.data == ''
                                                        " target="_blank" [href]="
                                                          GlobalConstants.staticFilesURL +
                                                          field.data
                                                        ">
                                                        <i [hidden]="
                                                            field.data == ''
                                                          " class="pi pi-file mx-2"></i>{{
                                                        "Add file"
                                                        | translator
                                                        }}
                                                      </a>
                                                    </div>
                                                    <div *ngSwitchCase="
                                                        'Data Item'
                                                      "></div>
                                                    <div *ngSwitchDefault>
                                                      {{ field.data }}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </ng-template>
                                          </p-accordionTab>
                                        </p-accordion>
                                      </div>
                                      <div *ngSwitchDefault>
                                        {{ field.data }}
                                      </div>
                                    </div>
                                  </div>
                                </ng-template>
                              </p-accordionTab>
                            </span>
                            <span *ngIf="log?.adminChange?.fields.length > 0">
                              <p class="color-bold mx-2">
                                {{ "Management updates" | translator }}
                              </p>
                              <span *ngFor="
                                  let field of log.adminChange?.fields;
                                  let i = index
                                ">
                                <p-accordionTab class="my-3" *ngIf="field.isChecked" iconPos="end">
                                  <ng-template pTemplate="header">
                                    <div class="d-flex align-items-center">
                                      <i [ngClass]="
                                          field.label?.icon + ' font-1_2rem'
                                        " class="m-2"></i>
                                      <span class="vertical-align-middle font-1_1rem">{{ field.label?.name }}</span>
                                    </div>
                                  </ng-template>
                                  <ng-template pTemplate="content">
                                    <div class="">
                                      <div [ngSwitch]="
                                          getFieldType(field.label?.type)
                                        ">
                                        <!-- For text -->
                                        <div *ngSwitchCase="'text'">
                                          <div class="d-flex flex-column mb-0 datacontent" *ngIf="field.data"
                                            [innerHTML]="field.data | safeHTML"></div>
                                        </div>
                                        <!-- Rich text -->
                                        <div *ngSwitchCase="'Rich text'">
                                          <div class="d-flex flex-column mb-0 datacontent" *ngIf="field.data"
                                            [innerHTML]="field.data | safeHTML"></div>
                                        </div>
                                        <div *ngSwitchCase="'Upload Image'">
                                          <img [hidden]="field.data == ''" class="img-fluid upload-img" [src]="
                                              GlobalConstants.staticFilesURL +
                                              field.data
                                            " />
                                        </div>
                                        <div *ngSwitchCase="'Upload Document'">
                                          <a class="doc-view" [hidden]="field.data == ''" target="_blank" [href]="
                                              GlobalConstants.staticFilesURL +
                                              field.data
                                            ">
                                            <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{ "Add file" |
                                            translator }}
                                          </a>
                                        </div>
                                        <div *ngSwitchCase="'Data Item'">
                                          <p>{{ field?.data?.name }}</p>
                                          <p-accordion class="w-full" [multiple]="true">
                                            <p-accordionTab class="my-3" *ngFor="
                                                let field of field.data.fields;
                                                let i = index
                                              " iconPos="end">
                                              <ng-template pTemplate="header">
                                                <div class="d-flex align-items-center">
                                                  <i [ngClass]="
                                                      field.label?.icon +
                                                      ' font-1_2rem'
                                                    " class="m-2"></i>
                                                  <span class="vertical-align-middle font-1_1rem">{{
                                                    field.label?.name
                                                    }}</span>
                                                </div>
                                              </ng-template>
                                              <ng-template pTemplate="content">
                                                <div class="row">
                                                  <div class="col-10">
                                                    <div [ngSwitch]="
                                                        getFieldType(
                                                          field.label?.type
                                                        )
                                                      ">
                                                      <!-- For text -->
                                                      <div *ngSwitchCase="'text'">
                                                        <div class="d-flex flex-column mb-0 datacontent"
                                                          *ngIf="field.data" [innerHTML]="
                                                            field.data
                                                              | safeHTML
                                                          "></div>
                                                      </div>
                                                      <!-- Rich text -->
                                                      <div *ngSwitchCase="
                                                          'Rich text'
                                                        ">
                                                        <div class="d-flex flex-column mb-0 datacontent"
                                                          *ngIf="field.data" [innerHTML]="
                                                            field.data
                                                              | safeHTML
                                                          "></div>
                                                      </div>
                                                      <div *ngSwitchCase="
                                                          'Upload Image'
                                                        ">
                                                        <img [hidden]="
                                                            field.data == ''
                                                          " class="img-fluid upload-img" [src]="
                                                            GlobalConstants.staticFilesURL +
                                                            field.data
                                                          " />
                                                      </div>
                                                      <div *ngSwitchCase="
                                                          'Upload Document'
                                                        ">
                                                        <a class="doc-view" [hidden]="
                                                            field.data == ''
                                                          " target="_blank" [href]="
                                                            GlobalConstants.staticFilesURL +
                                                            field.data
                                                          ">
                                                          <i [hidden]="
                                                              field.data == ''
                                                            " class="pi pi-file mx-2"></i>{{
                                                          "Add file"
                                                          | translator
                                                          }}
                                                        </a>
                                                      </div>
                                                      <div *ngSwitchCase="
                                                          'Data Item'
                                                        "></div>
                                                      <div *ngSwitchDefault>
                                                        {{ field.data }}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </ng-template>
                                            </p-accordionTab>
                                          </p-accordion>
                                        </div>
                                        <div *ngSwitchDefault>
                                          {{ field.data }}
                                        </div>
                                      </div>
                                    </div>
                                  </ng-template>
                                </p-accordionTab>
                              </span>
                            </span>
                          </p-accordion>
                        </ng-template>
                      </p-accordionTab>
                    </p-accordion>
                  </span>
                </span>
                <!-- End Edit Log -->

                <!-- Delete Log -->
                <span *ngIf="log.type == 'DELETE'">
                  <div class="flex-align-flex">
                    <span class="mt-2">
                      <img class="svg-icon" src="../assets/icons/delete/24-@1.5x.svg" alt="loading" />
                      <span class="color-bold mx-2">{{
                        "delete" | translator
                        }}</span>

                    </span>
                    <span>
                      <!--  -->
                      <i pTooltip="{{'Undo delete' | translator}}" tooltipPosition="top"
                        (click)="confirmUndoDelete(log)" *ngIf="log.status == 'APPROVED' && !log.isUndoDelete"
                        class="pi pi-reply v4-pi-rep"></i>
                      <span *ngIf="log.status == 'APPROVED' && log.isUndoDelete"
                        class="pi pi-check-square v4-pi-rep">{{'Returned' | translator}}</span>
                    </span>
                  </div>
                  <p-accordion (onOpen)="openLog(log)" (onClose)="openLog(log)" class="w-full" [multiple]="true">
                    <p-accordionTab class="my-3">
                      <ng-template pTemplate="header">
                        <div class="container-fluid flex-mob-web">
                          <div class="d-flex">
                            <i [ngClass]="
                                log?.before?.dataview?.type?.icon +
                                ' font-1_2rem'
                              " class="m-2"></i>
                            <span class="vertical-align-middle font-1_1rem d-flex">{{ log?.before?.name }} ({{
                              log?.before?.dataview?.type?.arabic
                              }})</span>
                          </div>
                          <div class="mob-mr">
                            <span>({{ log.createdAt | date }})</span>
                          </div>
                        </div>
                      </ng-template>
                      <!-- Name Is Edited -->
                      <ng-template pTemplate="content">
                        <p class="color-bold">
                          <i class="pi pi-trash"></i>&nbsp;{{
                          "Delete request" | translator
                          }}&nbsp;
                        </p>
                      </ng-template>
                    </p-accordionTab>
                  </p-accordion>
                </span>
                <!-- End Delete log -->

                <!-- Add Service -->
                <span *ngIf="log?.type == 'ADD SERVICE'">
                  <span class="d-flex mt-2">
                    <img class="svg-icon" src="../assets/icons/Add/24@1.5x.svg" alt="loading" />
                    <span class="vertical-align-middle color-bold m-2">{{
                      "Add data" | translator
                      }}</span>
                  </span>
                  <p-accordion (onOpen)="openLog(log)" (onClose)="openLog(log)">
                    <p-accordionTab>
                      <ng-template pTemplate="header">
                        <div class="flex align-items-center w-100">
                          <div class="d-flex justify-content-between">
                            <div class="d-flex">
                              <!-- <i [ngClass]="'pi pi-plus-circle'" class="m-2"></i>
                                                        <span class="vertical-align-middle m-2">{{"Add data"| translator}}</span> -->
                              <i [ngClass]="
                                  getDataTypeIcon(log?.after.type) +
                                  ' font-1_2rem'
                                " class="m-2"></i>
                              <span class="vertical-align-middle font-1_1rem d-flex">
                                {{ getDataTypeName(log?.after.type) }}({{
                                log.after?.name
                                }})</span>
                            </div>
                            <div>
                              <span>({{ log?.createdAt | date }})</span>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                      <!-- User data changes-->
                      <div>
                        <div class="card-body">
                          <p-accordion class="w-full" [multiple]="true">
                            <p-accordionTab *ngFor="
                                let field of log?.after.fields;
                                let i = index
                              " iconPos="end">
                              <ng-template pTemplate="header">
                                <div class="flex align-items-center">
                                  <span class="vertical-align-middle m-2">{{
                                    field?.label
                                    }}</span>
                                </div>
                              </ng-template>
                              <ng-template pTemplate="content">
                                <!-- For PENDING logs  -->
                                <div *ngIf="log.status == 'PENDING'" class="">
                                  <div class="flex-column mb-0 datacontent" [ngSwitch]="
                                      getDataTypeNameByDataFields(field.type)
                                    ">
                                    <!-- For text -->
                                    <div *ngSwitchCase="'text'">
                                      <span class="p-input-icon-right w-100">
                                        <i class="pi pi-clone"></i>
                                        <input pInputText [(ngModel)]="field.data" class="w-100" type="text" />
                                      </span>
                                    </div>
                                    <!-- Rich text -->
                                    <div class="w-100" *ngSwitchCase="'Rich text'">
                                      <p-editor [(ngModel)]="field.data" [style]="{ height: '120px' }"></p-editor>
                                    </div>
                                    <!-- Images -->
                                    <div *ngSwitchCase="'Upload Image'">
                                      <img [hidden]="field.data == ''" class="img-fluid" style="width: 100px" [src]="
                                          GlobalConstants.staticFilesURL +
                                          field.data
                                        " />
                                      <p-fileUpload mode="basic" chooseLabel="Choose" name="demo[]"
                                        [url]="apilink + 'files/ouImage'" [auto]="true" chooseLabel="Browse"
                                        accept="image/*" [maxFileSize]="1000000" (onUpload)="
                                          field.data =
                                            $event.originalEvent.body.URL
                                        "></p-fileUpload>
                                    </div>
                                    <!-- Document -->
                                    <div *ngSwitchCase="'Upload Document'">
                                      <a class="doc-view my-2" [hidden]="field.data == ''" target="_blank" [href]="
                                          GlobalConstants.staticFilesURL +
                                          field.data
                                        ">
                                        <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{ "Add file" |
                                        translator }}
                                      </a>
                                      <p-fileUpload mode="basic" chooseLabel="Choose" name="demo[]"
                                        [url]="apilink + 'files/upload-files'" [auto]="true" chooseLabel="Add File"
                                        [maxFileSize]="1000000" (onUpload)="
                                          field.data =
                                            $event.originalEvent.body.URL
                                        "></p-fileUpload>
                                    </div>
                                    <div *ngSwitchCase="'Data Item'">
                                      <button type="submit" (click)="toggleModal(i)" pButton pRipple
                                        label="{{ 'to update' | translator }}" icon="pi pi-fw pi-plus-circle"
                                        class="w-full my-3"></button>
                                      <p-dialog [blockScroll]="true" [draggable]="false"
                                        header="{{ 'Select' | translator }}" [(visible)]="modalVisibilities[i]" [style]="{
                                          width: '95vw',
                                          maxWidth: '1200px'
                                        }">
                                        <app-select-service (currentDataItem)="
                                            changeCurrentDataItem(
                                              $event,
                                              field,
                                              i
                                            )
                                          "></app-select-service>
                                      </p-dialog>
                                      <p class="font-bold" *ngIf="field.data">
                                        {{ field.data.name }}
                                      </p>
                                    </div>
                                    <div *ngSwitchDefault></div>
                                  </div>
                                </div>
                                <!-- For APPROVED / REJECTED logs -->
                                <div *ngIf="log.status != 'PENDING'" class="d-flex justify-content-between">
                                  <div class="d-flex flex-column mb-0 datacontent" [ngSwitch]="
                                      getDataTypeNameByDataFields(field.type)
                                    ">
                                    <!-- For text -->
                                    <div *ngSwitchCase="'text'">
                                      <span class="p-input-icon-right w-100">{{
                                        field.data
                                        }}</span>
                                    </div>
                                    <!-- Rich text -->
                                    <div *ngSwitchCase="'Rich text'">
                                      <span [innerHTML]="field.data | safeHTML" class="m-0"></span>
                                    </div>
                                    <!-- Images -->
                                    <div *ngSwitchCase="'Upload Image'">
                                      <img [hidden]="field.data == ''" class="img-fluid" style="width: 100px" [src]="
                                          GlobalConstants.staticFilesURL +
                                          field.data
                                        " />
                                    </div>
                                    <!-- Document -->
                                    <div *ngSwitchCase="'Upload Document'">
                                      <a class="doc-view" [hidden]="field.data == ''" target="_blank" [href]="
                                          GlobalConstants.staticFilesURL +
                                          field.data
                                        ">
                                        <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{ "Add file" |
                                        translator }}
                                      </a>
                                    </div>
                                    <div *ngSwitchCase="'Data Item'">
                                      <p class="color-bold" *ngIf="field.data">
                                        {{ field.data.name }}
                                      </p>
                                    </div>
                                    <div *ngSwitchDefault></div>
                                  </div>
                                </div>
                              </ng-template>
                            </p-accordionTab>
                          </p-accordion>
                        </div>
                      </div>
                      <!-- Admin data changes-->
                      <div *ngIf="log.adminChange?.fields?.length > 0">
                        <div class="card-body">
                          <h4 class="card-title" style="font-weight: 600; color: var(--color-1)">
                            <i [class]="getDataTypeIcon(log.after.type)"></i>
                            {{ getDataTypeName(log.after.type) }}
                            ({{ "Update from management" | translator }})
                          </h4>
                          <p-accordion class="w-full" [multiple]="true" [activeIndex]="0">
                            <p-accordionTab *ngFor="
                                let field of log.adminChange?.fields;
                                let i = index
                              " iconPos="end">
                              <ng-template pTemplate="header">
                                <div class="flex align-items-center">
                                  <span class="vertical-align-middle m-2">{{
                                    field?.label
                                    }}</span>
                                </div>
                              </ng-template>
                              <ng-template pTemplate="content">
                                <!-- For Admin changes logs -->
                                <div class="d-flex justify-content-between">
                                  <div class="d-flex flex-column mb-0 datacontent" [ngSwitch]="
                                      getDataTypeNameByDataFields(field.type)
                                    ">
                                    <!-- For text -->
                                    <div *ngSwitchCase="'text'">
                                      <span class="p-input-icon-right w-100">{{
                                        field.data
                                        }}</span>
                                    </div>
                                    <!-- Rich text -->
                                    <div *ngSwitchCase="'Rich text'">
                                      <span [innerHTML]="field.data | safeHTML" class="m-0"></span>
                                    </div>
                                    <!-- Images -->
                                    <div *ngSwitchCase="'Upload Image'">
                                      <img [hidden]="field.data == ''" class="img-fluid" style="width: 100px" [src]="
                                          GlobalConstants.staticFilesURL +
                                          field.data
                                        " />
                                    </div>
                                    <!-- Document -->
                                    <div *ngSwitchCase="'Upload Document'">
                                      <a class="doc-view" [hidden]="field.data == ''" target="_blank" [href]="
                                          GlobalConstants.staticFilesURL +
                                          field.data
                                        ">
                                        <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{ "Add file" |
                                        translator }}
                                      </a>
                                    </div>
                                    <!-- Data Item -->
                                    <div *ngSwitchCase="'Data Item'">
                                      <p class="font-bold" *ngIf="field.data">
                                        {{ field.data.name }}
                                      </p>
                                    </div>
                                    <div *ngSwitchDefault></div>
                                  </div>
                                </div>
                              </ng-template>
                            </p-accordionTab>
                          </p-accordion>
                        </div>
                      </div>
                    </p-accordionTab>
                  </p-accordion>
                </span>
                <!-- End Add Service -->

                <!-- Change Ou Logs -->
                <span *ngIf="log.type == 'OU CHANGE'">
                  <span class="flex-align-flex mt-2">
                    <img class="svg-icon mx-2" src="../assets/icons/Edit/24-dark@1.5x.svg" alt="loading" />
                    <span class="color-bold">{{
                      "Change classification" | translator
                      }}</span>
                  </span>
                  <div class="container-fluid flex-mob-web">
                    <div class="d-flex">
                      <i [ngClass]="
                          log?.before?.dataview?.type?.icon + ' font-1_2rem'
                        " class="m-2"></i>
                      <span class="vertical-align-middle font-1_1rem d-flex v4-color-white">{{ log?.before?.name }} ({{
                        log?.before?.dataview?.type?.arabic
                        }})</span>
                    </div>
                    <div class="mob-mr">
                      <span class="v4-color-white">({{ log.createdAt | date }})</span>
                    </div>
                  </div>
                  <p class="color-bold mx-2 mb-0">
                    {{ "Before updating" | translator }}
                  </p>
                  <!-- breadcrumb -->
                  <div class="d-flex flex-row align-items-center wrapp">
                    <span class="d-flex align-items-center my-1" *ngFor="
                        let item of sortBreadcrums(
                          log?.before?.dataview?.breadcrumbs
                        );
                        let i = index
                      " [routerLink]="item?.routerLink">
                      <span class="custom-bredcrum-btn d-flex align-items-center">
                        <i [hidden]="item?.image_sq" class="{{ item?.icon }} me-1"></i>
                        <img [hidden]="!item?.image_sq" [src]="staticURL + item?.image_sq"
                          style="max-height: 1.2rem; max-width: 1.2rem" class="blacknWhite img-fluid me-1" />
                        <span class="d-flex">{{ item?.label }}</span>
                      </span>
                      <span class=""><i class="pi pi-fw pi-angle-left"></i></span>
                    </span>
                  </div>
                  <!-- breadcrumb end -->
                  <p class="color-bold mx-2 mb-0">
                    {{ "After the update" | translator }}
                  </p>
                  <div class="d-flex flex-row align-items-center wrapp">
                    <span class="d-flex align-items-center my-1" *ngFor="
                        let item of sortBreadcrums(
                          log?.after?.newOu?.breadcrumb
                        );
                        let i = index
                      " [routerLink]="item?.routerLink">
                      <span style="background-color: #1e2253" class="custom-bredcrum-btn d-flex align-items-center">
                        <i [hidden]="item?.icon" class="{{ item?.icon }} me-1"></i>
                        <img [hidden]="!item?.icon" [src]="staticURL + item?.icon"
                          style="max-height: 1.2rem; max-width: 1.2rem" class="blacknWhite img-fluid me-1" />
                        <span class="inherit">{{ item?.label }}</span>
                      </span>
                      <span class=""><i class="pi pi-fw pi-angle-left"></i></span>
                    </span>
                  </div>
                  <!-- <div class="d-flex flex-row align-items-center wrapp">
                                        <span class="d-flex align-items-center my-1">
                                            <span 
                                                class="custom-bredcrum-btn d-flex align-items-center">
                                                <i [hidden]="log.after.newOu?.data" class="{{log.after.newOu?.data}} me-1"></i>
                                                <img [hidden]="!log.after.newOu?.data" [src]="staticURL+log.after.newOu?.data"
                                                    style="max-height: 1.2rem; max-width: 1.2rem;"
                                                    class="blacknWhite img-fluid me-1">
                                                {{log.after.newOu?.name}}
                                            </span>
                                        </span>
                                    </div> -->
                </span>
                <!-- Change Ou Logs -->

                <hr />
                <div class="mx-3">
                  <h6>
                    <b class="color-bold"><i class="pi pi-exclamation-circle mx-2 color-bold"></i>{{ "Reason" |
                      translator }}</b>
                  </h6>
                  <span class="v4-color-white" [innerHTML]="log.reason | safeHTML"></span>
                </div>

                <hr />

                <div class="mx-3" *ngIf="log.status == 'REJECTED'">
                  <h6>
                    <b class="color-bold">{{
                      "the reason of refuse" | translator
                      }}</b>
                  </h6>
                  <span class="v4-color-white" [innerHTML]="log.reject_reason | safeHTML"></span>
                </div>

                <!-- Reject Reason Modal -->
                <p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="rejectionModal"
                  [style]="{ width: '95vw', maxWidth: '1000px' }">
                  <ng-template pTemplate="header">
                    <span class="text-xl font-bold">{{
                      "Confirmation message" | translator
                      }}</span>
                  </ng-template>
                  <p>
                    {{
                    "Are you sure you want to decline the update request?"
                    | translator
                    }}
                  </p>
                  <label>{{ "the reason of refuse" | translator }} :</label>
                  <p-editor [(ngModel)]="reason" [style]="{ height: '120px' }"></p-editor>
                  <ng-template pTemplate="footer">
                    <p-button [disabled]="reason == undefined" icon="pi pi-check" (click)="RejectLog(log)"
                      label="{{ 'OK' | translator }}" styleClass="p-button-text"></p-button>
                    <!-- <button class="v4-btn-every py-2" [disabled]="reason == undefined" (click)="RejectLog(log)"
                      >{{ 'OK' | translator }}<i class="pi pi-check v4-ml-2"></i></button> -->
                  </ng-template>
                </p-dialog>
                <!-- End Rejection Modal -->

                <div class="row mx-1 d-flex align-items-center">
                  <div class="col-md-8 col-12 p-0">
                    <div class="flex align-items-center">
                      <span>
                        <h6>
                          <b class="color-bold"><i class="pi pi-user-edit mx-2 color-bold"></i>
                            {{ "Request before" | translator }} :
                          </b>
                          <span class="v4-color-white">
                            {{ log.updated_by.name.first }}
                            {{ log.updated_by.name.middle }}
                            {{ log.updated_by?.name?.last }}
                          </span>
                        </h6>
                        <h6>
                          <b class="color-bold"><i class="fa-solid fa-envelope mx-2 color-bold"></i>
                            {{ "Email" | translator }} :
                          </b>
                          <span class="v4-color-white">
                            {{ log.updated_by?.email }}
                          </span>
                        </h6>
                        <h6>
                          <b class="color-bold"><i class="fa fa-solid fa-phone mx-2 color-bold"></i>
                            {{ "Phone Number" | translator }} :
                          </b>
                          <span class="v4-color-white">
                            {{ log.updated_by?.phone }}
                          </span>
                        </h6>
                        <h6>
                          <b class="color-bold"><i class="fa fa-solid fa-location-dot mx-2 color-bold"></i>
                            {{ "City" | translator }} :
                          </b>
                          <span class="v4-color-white">
                            {{ log.updated_by?.location?.name }}
                          </span>
                        </h6>
                        <h6 *ngIf="log?.dataLinkID">
                          <b class="color-bold"><i class="fa fa-solid fa-external-link mx-2 color-bold"></i>
                            {{ "Link" | translator }} :
                          </b>
                          <span class="v4-color-white">
                            <a class="btn text-white" [href]="GlobalConstants.siteUrl + 'data/' + log?.dataLinkID" target="_blank">
                              {{ log?.dataLinkID }}
                            </a>
                          </span>
                        </h6>
                      </span>

                      <span *ngIf="log?.status != 'PENDING'">
                        <h6>
                          <b class="color-bold"><i class="fa-solid fa-user-check mx-2"></i>
                            <span class="v4-color-white" *ngIf="log?.status == 'APPROVED'">{{ "Approved by" | translator
                              }} :</span>
                            <span class="v4-color-white" *ngIf="log?.status != 'APPROVED'">{{ "Rejected before" |
                              translator }} :</span>
                          </b>
                          <span class="v4-color-white">
                            {{ log?.approved_by?.name?.first }}
                            {{ log?.approved_by?.name?.middle }}
                            {{ log?.approved_by?.name?.last }}
                          </span>
                        </h6>

                        <h6>
                          <b class="color-bold"><i class="fa-solid fa-envelope mx-2 color-bold"></i>
                            {{ "Email" | translator }} :
                          </b>
                          <span class="v4-color-white">
                            {{ log.approved_by?.email }}
                          </span>
                        </h6>
                        <h6>
                          <b class="color-bold"><i class="fa fa-solid fa-phone mx-2 color-bold"></i>
                            {{ "Phone Number" | translator }} :
                          </b>
                          <span class="v4-color-white">
                            {{ log.approved_by?.phone }}
                          </span>
                        </h6>
                        <h6>
                          <b class="color-bold"><i class="fa fa-solid fa-location-dot mx-2 color-bold"></i>
                            {{ "City" | translator }} :
                          </b>
                          <span class="v4-color-white">
                            {{ log.approved_by?.location?.name }}
                          </span>
                        </h6>
                      </span>

                      <h6 *ngIf="log?.status != 'PENDING'">
                        <b class="color-bold">
                          <i class="pi pi-calendar-plus mx-2"></i>
                          <span *ngIf="log?.status == 'APPROVED'">
                            {{ "approval date" | translator }} :
                          </span>
                          <span *ngIf="log?.status != 'APPROVED'">
                            {{ "Date of rejection" | translator }} :
                          </span>
                        </b>
                        <span class="v4-color-white">
                          {{ log?.updatedAt | date }}
                        </span>
                      </h6>
                    </div>
                  </div>
                  <div *ngIf="log?.status == 'PENDING' && hasPermission()"
                    class="col-md-4 col-12 d-flex justify-content-end p-0 my-2">
                    <button class="v4-mini-btn">
                      <i (click)="confirmApprove(log)" class="pi pi-check"></i>
                    </button>
                    <button class="v4-mini-btn">
                      <i (click)="confirmReject()" class="pi pi-times"></i>
                    </button>
                  </div>
                </div>
                <!-- End Edit Log -->
                <!-- Reject Reason Modal -->
                <p-dialog appendTo="body" header="Header" [(visible)]="rejectionModal"
                  [style]="{ width: '95vw', maxWidth: '1000px' }">
                  <ng-template pTemplate="header">
                    <span class="text-xl font-bold">{{
                      "Confirmation message" | translator
                      }}</span>
                  </ng-template>
                  <p class="color-bold">
                    {{
                    "Are you sure you want to decline the update request?"
                    | translator
                    }}
                  </p>
                  <label class="color-bold mb-2">{{ "the reason of refuse" | translator }} :</label>
                  <p-editor [(ngModel)]="reason" [style]="{ height: '120px' }"></p-editor>
                  <ng-template pTemplate="footer">
                    <button class="v4-btn-every py-2" [disabled]="reason == undefined" icon="" (click)="RejectLog(log)">
                      {{ "OK" | translator }}<i class="pi pi-check v4-ml-2"></i>
                    </button>
                  </ng-template>
                </p-dialog>
                <!-- End Rejection Modal -->
              </div>
            </div>

            <div class="mb-5 v4-pagination">
              <p-paginator class="v4-pagination" [hidden]="data?.length <= 0" appendTo="body" (onPageChange)="onPageChange($event)"
                [first]="first" [rows]="rows" [totalRecords]="totalRecords"
                [rowsPerPageOptions]="[10, 20, 30]"></p-paginator>
            </div>
          </div>
        </div>

        <!-- View Of the Service   'sticky-column': isScrolled && !showFilters,
            'filter-stickey': isScrolled && showFilters  [ngClass]="{ 'sticky-content': isScrolled }"-->
        <div *ngIf="side_view" [ngClass]="{
            'col-lg-6 col-md-6 col-12  slide-left': side_view,
            'class-for-false': !side_view,
          
          }" class="mob-top-wiew" [style.top]="topValue + 'px'"
          style="position: absolute !important; left: 0px !important">
          <div>
            <span class="d-flex align-items-center white-head-box">
              <img class="svg-icon-heading" src="../../../../../assets/v-4-icone/Layer-3.svg" alt="loading" />
              <h5 class="heading mx-2">
                {{ "Content before update" | translator }}
              </h5>
            </span>
            <div class="{{
                logStatus_set == 'PENDING' || logStatus_set == 'APPROVED'
                  ? 'logs-box-view w-100'
                  : 'log-default w-100'
              }}">
              <div class="row my-2 d-flex align-items-center">
                <div class="col-md-12 col-12">
                  <div class="d-flex my-2">
                    <div class="column pos-rel w-100">
                      <h4 class="card-title mx-2" style="font-weight: 500; color: white">
                        {{ side_view.name }}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <!-- breadcrumb -->
              <div class="d-flex flex-row align-items-center wrapp">
                <span class="d-flex align-items-center my-1" *ngFor="let item of side_view?.breadcrumbs; let i = index"
                  [routerLink]="item?.routerLink">
                  <span class="custom-bredcrum-btn d-flex align-items-center">
                    <i [hidden]="item?.image_sq" class="{{ item?.icon }} me-1"></i>
                    <img [hidden]="!item?.image_sq" [src]="staticURL + item?.image_sq"
                      style="max-height: 1.2rem; max-width: 1.2rem" class="blacknWhite img-fluid me-1" />
                    {{ item?.label }}
                  </span>
                  <span class=""><i class="pi pi-fw pi-angle-left v4-bredcrum-icn"></i></span>
                </span>
              </div>
              <!-- breadcrumb end -->
              <div class="overflow-ui">
                <p-accordion class="w-full" [multiple]="true">
                  <p-accordionTab class="my-3" *ngFor="let field of side_view?.fields; let i = index" iconPos="end">
                    <ng-template pTemplate="header">
                      <div class="d-flex align-items-center">
                        <i [ngClass]="field.label?.icon + ' font-1_2rem'" class="m-2"></i>
                        <span class="vertical-align-middle font-1_1rem">{{
                          field.label?.name
                          }}</span>
                      </div>
                    </ng-template>
                    <ng-template pTemplate="content">
                      <div class="row">
                        <!-- For View -->
                        <div class="col-12">
                          <div [ngSwitch]="getFieldType(field.label?.type)">
                            <!-- For text -->
                            <div *ngSwitchCase="'text'">
                              <div class="d-flex flex-column mb-0 datacontent" *ngIf="field.data"
                                [innerHTML]="field.data | safeHTML"></div>
                            </div>
                            <!-- Rich text -->
                            <div *ngSwitchCase="'Rich text'">
                              <div class="d-flex flex-column mb-0 datacontent" *ngIf="field.data"
                                [innerHTML]="field.data | safeHTML"></div>
                            </div>
                            <div *ngSwitchCase="'Upload Image'">
                              <img [hidden]="field.data == ''" class="img-fluid upload-img" [src]="
                                  GlobalConstants.staticFilesURL + field.data
                                " />
                            </div>
                            <div *ngSwitchCase="'Upload Document'">
                              <a class="doc-view" [hidden]="field.data == ''" target="_blank" [href]="
                                  GlobalConstants.staticFilesURL + field.data
                                ">
                                <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{ "Add file" | translator }}
                              </a>
                            </div>
                            <div *ngSwitchCase="'Data Item'">
                              <p-accordion class="w-full" [multiple]="true">
                                <p-accordionTab class="my-3" *ngFor="
                                    let field of field.data.fields;
                                    let i = index
                                  " iconPos="end" [selected]="i == 0 || i == 1">
                                  <ng-template pTemplate="header">
                                    <div class="d-flex align-items-center">
                                      <i [ngClass]="
                                          field.label?.icon + ' font-1_2rem'
                                        " class="m-2"></i>
                                      <span class="vertical-align-middle font-1_1rem">{{ field.label?.name }}</span>
                                    </div>
                                  </ng-template>
                                  <ng-template pTemplate="content">
                                    <div class="row">
                                      <div class="col-10">
                                        <div [ngSwitch]="
                                            getFieldType(field.label?.type)
                                          ">
                                          <!-- For text -->
                                          <div *ngSwitchCase="'text'">
                                            <div class="d-flex flex-column mb-0 datacontent" *ngIf="field.data"
                                              [innerHTML]="
                                                field.data | safeHTML
                                              "></div>
                                          </div>
                                          <!-- Rich text -->
                                          <div *ngSwitchCase="'Rich text'">
                                            <div class="d-flex flex-column mb-0 datacontent" *ngIf="field.data"
                                              [innerHTML]="
                                                field.data | safeHTML
                                              "></div>
                                          </div>
                                          <div *ngSwitchCase="'Upload Image'">
                                            <img [hidden]="field.data == ''" class="img-fluid upload-img" [src]="
                                                GlobalConstants.staticFilesURL +
                                                field.data
                                              " />
                                          </div>
                                          <div *ngSwitchCase="'Upload Document'">
                                            <a class="doc-view" [hidden]="field.data == ''" target="_blank" [href]="
                                                GlobalConstants.staticFilesURL +
                                                field.data
                                              ">
                                              <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{ "Add file" |
                                              translator }}
                                            </a>
                                          </div>
                                          <div *ngSwitchCase="'Data Item'"></div>
                                          <div *ngSwitchDefault>
                                            {{ field.data }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </ng-template>
                                </p-accordionTab>
                              </p-accordion>
                            </div>
                            <div *ngSwitchDefault>{{ field.data }}</div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </p-accordionTab>
                </p-accordion>
              </div>
            </div>
          </div>
        </div>
        <!-- End View Of the Service -->
      </div>
    </div>

    <!-- </div> -->
  </div>
  <!-- Search Section -->
</section>
<!-- search section end -->

<p-toast></p-toast>

<!-- Confirm Modal -->
<p-confirmDialog #cd [style]="{ width: '50vw' }">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="pi pi-times" label="{{ 'cancellation' | translator }}"
      (click)="cd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" label="{{ 'OK' | translator }}" (click)="cd.accept()"></button>
      </ng-template>
</p-confirmDialog>

<app-footer></app-footer>

<!-- breadcrumb -->
<!-- <div class="d-flex flex-row align-items-center wrapp">
    <span class="d-flex align-items-center my-1"
        *ngFor="let item of currentview.breadcrumbs; let i = index" [routerLink]="item.routerLink">
        <span class="custom-bredcrum-btn d-flex align-items-center">
            <i [hidden]="item.image_sq" class="{{item.icon}} me-1"></i>
            <img [hidden]="!item.image_sq" [src]="staticURL+item.image_sq"
                style="max-height: 1.2rem; max-width: 1.2rem;" class="blacknWhite img-fluid me-1">
            {{item.name}}
        </span>
        <span class=""><i class="pi pi-fw pi-angle-left"></i></span>
    </span>
</div> -->
<!-- breadcrumb end -->